export const ArrowRight = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
        <path d="M6 3.73332L10 8.39999L6 13.0667" stroke="#506690" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
}